import { safeDefine } from "../../registration/safe-define.js";
import { ControlsGroupElement } from "../../ui/controls/group.js";
//#region src/define/ui/controls-group.ts
safeDefine(ControlsGroupElement);
//#endregion

//# sourceMappingURL=controls-group.js.map